const referralActionTypes = Object.freeze({
  denegate: 1,
  denegateLinked: 2,
  actionPlan: 3,
  breachReason: 4,
});

export default referralActionTypes;
